import { commonNouns } from 'lib/localization'
import { defineMessages } from 'react-intl'

const intlNames = defineMessages({
  terrain: {
    id: 'tileServices.terrain',
    defaultMessage: 'Terrain'
  },
  satellite: {
    id: 'tileServices.satellite',
    defaultMessage: 'Satellite'
  },
  hybrid: {
    id: 'tileServices.hybrid',
    defaultMessage: 'Hybrid'
  },
  osmCycle: {
    id: 'tileServices.osmCycle',
    defaultMessage: 'OSM Cycle'
  },
  osmOutdoor: {
    id: 'tileServices.osmOutdoor',
    defaultMessage: 'OSM Outdoor'
  },
  esriTopo: {
    id: 'tileServices.esriTopo',
    defaultMessage: 'ESRI Topo',
    description: 'Topo is short for Topographic, a type of map'
  },
  usgsTopo: {
    id: 'tileServices.usgsTopo',
    defaultMessage: 'USGS Topo',
    description: 'Topo is short for Topographic, a type of map'
  },
  usgsTopoLegacy: {
    id: 'tileServices.usgsTopoLegacy',
    defaultMessage: 'USGS Scans',
    description: 'Scans of old USGS maps'
  }
})

export const tileServices = {
  roadmap: { id: 'roadmap', name: 'Map', intlName: commonNouns.map, enabled: true, routingService: 'google', type: 'google' },
  terrain: { id: 'terrain', name: 'Terrain', intlName: intlNames.terrain, enabled: true, routingService: 'google', type: 'google' },
  satellite: { id: 'satellite', name: 'Satellite', intlName: intlNames.satellite, enabled: true, routingService: 'google', type: 'google' },
  hybrid: { id: 'hybrid', name: 'Hybrid', intlName: intlNames.hybrid, enabled: true, routingService: 'google', type: 'google' },
  rwgps: {
    id: 'rwgps',
    name: 'RWGPS',
    maxZoom: 18,
    minZoom: 1,
    enabled: true,
    type: 'osm',
    url: '//tile-{s}.ridewithgps.com/rwgps/',
    routingService: 'rwgps',
    attribution: '© OpenStreetMap contributors'
  },
  osm: {
    id: 'osm',
    name: 'OSM',
    maxZoom: 18,
    minZoom: 3,
    enabled: true,
    type: 'osm',
    url: '//{s}.tile.openstreetmap.org/',
    routingService: 'rwgps',
    attribution: '© OpenStreetMap contributors'
  },
  osmCycle: {
    id: 'osmCycle',
    name: 'OSM Cycle',
    intlName: intlNames.osmCycle,
    key: 'a1f31ce03c41486894ffd9ed393ec1ea',
    maxZoom: 18,
    minZoom: 3,
    enabled: true,
    type: 'osm',
    url: '//{s}.tile.thunderforest.com/cycle/',
    routingService: 'rwgps',
    attribution: 'Maps © Thunderforest, Data © OpenStreetMap contributors'
  },
  osmOutdoor: {
    id: 'osmOutdoor',
    name: 'OSM Outdoor',
    intlName: intlNames.osmOutdoor,
    key: 'a1f31ce03c41486894ffd9ed393ec1ea',
    maxZoom: 18,
    minZoom: 3,
    enabled: true,
    type: 'osm',
    url: '//{s}.tile.thunderforest.com/outdoors/',
    routingService: 'rwgps',
    attribution: 'Maps © Thunderforest, Data © OpenStreetMap contributors'
  },
  esriTopo: {
    id: 'esriTopo',
    name: 'Esri Topo',
    intlName: intlNames.esriTopo,
    maxZoom: 17,
    minZoom: 1,
    enabled: true,
    type: 'arcgis',
    url: '//server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/',
    mapboxTiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}.png'],
    routingService: 'rwgps',
    attribution: '© Esri'
  },
  usgsTopo: {
    id: 'usgsTopo',
    name: 'USGS Topo',
    intlName: intlNames.usgsTopo,
    maxZoom: 16,
    minZoom: 3,
    enabled: true,
    type: 'arcgis',
    url: '//basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/',
    mapboxTiles: ['https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}?token='],
    routingService: 'rwgps',
    attribution: '© USGS/ArcGIS'
  },
  usgsTopoLegacy: {
    id: 'usgsTopoLegacy',
    name: 'USGS Scans',
    intlName: intlNames.usgsTopoLegacy,
    maxZoom: 14,
    minZoom: 3,
    enabled: true,
    type: 'arcgis',
    url: '//services.arcgisonline.com/arcgis/rest/services/USA_Topo_Maps/MapServer/tile/',
    mapboxTiles: ['https://services.arcgisonline.com/arcgis/rest/services/USA_Topo_Maps/MapServer/tile/{z}/{y}/{x}.png'],
    routingService: 'rwgps',
    attribution: '© USGS/ArcGIS'
  }
}
